import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'accent' | 'secondary' | 'ghost';
interface ButtonProps {
  to?: string;
  href?: string;
  onClick?: () => void;
  variant?: Variant;
  size?: 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
}
const base = 'inline-flex items-center justify-center gap-2 rounded-full font-medium transition-colors duration-150 ease-republic disabled:cursor-not-allowed disabled:opacity-40';
const sizes = {
  md: 'px-6 py-3 text-sm',
  lg: 'px-8 py-4 text-base'
};
const variants: Record<Variant, string> = {
  primary: 'bg-ink text-cream hover:bg-ink-soft',
  accent: 'bg-brick text-cream hover:bg-brick-deep',
  secondary: 'border border-ink/20 text-ink hover:border-ink hover:bg-ink hover:text-cream',
  ghost: 'border border-cream/30 text-cream hover:bg-cream hover:text-ink'
};
export function Button({
  to,
  href,
  onClick,
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  type = 'button',
  disabled = false
}: ButtonProps) {
  const classes = `${base} ${sizes[size]} ${variants[variant]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} data-id="element-241" data-mp="tmx1zmuomdfd">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} data-id="element-242" data-mp="onarvma5hdas">
        {children}
      </a>;
  }
  return <button type={type} onClick={onClick} disabled={disabled} className={classes} data-id="element-243" data-mp="12nbrkyeoieoo">
      {children}
    </button>;
}